import styled from "styled-components";
import PublicSelect from "../../publics/PublicSelect";
import { CLOUDN_COLORS } from "../../../constants/colors";
import { ShowcaseSelectBoxProps } from "../../../constants/types";
import { SelectChangeEvent } from "@mui/material";
import {
  getSiteSelectList,
  getZoneSelectList,
} from "../../../constants/function";

const EplusSelectBox = (props: ShowcaseSelectBoxProps) => {
  const onChangeSiteNo = (e: SelectChangeEvent) => {
    props.option.setOptions({
      ...props.option.options,
      eplus: {
        ...props.option.options.eplus,
        siteNo: e.target.value,
      },
    });
  };
  const onChangeZoneNo = (e: SelectChangeEvent) => {
    props.option.setOptions({
      ...props.option.options,
      eplus: {
        ...props.option.options.showcase,
        zoneNo: e.target.value,
      },
    });
  };
  return (
    <Container>
      <PublicSelect
        height={100}
        items={getSiteSelectList(props.categories)}
        onChange={onChangeSiteNo}
        value={props.option.options.eplus.siteNo}
        width={30}
        placeholder="프로젝트 선택"
        name="siteNo"
        margin="0 2% 0 0"
        all
      />
      <PublicSelect
        height={100}
        items={getZoneSelectList(
          props.categories,
          props.option.options.eplus.siteNo
        )}
        onChange={onChangeZoneNo}
        value={props.option.options.eplus.zoneNo}
        width={30}
        placeholder="지점 선택"
        name="zoneNo"
        all
      />
    </Container>
  );
};

export default EplusSelectBox;

const Container = styled.div`
  width: 100%;
  height: 5%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
